import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import slider2 from '../img/slider/slider21.png';
import slider3 from '../img/slider/slider51.png';
import slider1 from '../img/slider/slider61.png';
import { default as slider4 } from '../img/slider/slider71.png';
import './ImageCarousel.css';

function ImageCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        <div className="carousel-slide">
          <img src={slider1} alt="Slide 1" />
          {/* <div className="carousel-caption">
            <h3>Slide 1</h3>
            <p>This is the first slide.</p>
          </div> */}
        </div>
        <div className="carousel-slide">
          <img src={slider2} alt="Slide 21" />
          {/* <div className="carousel-caption">
            <h3>Slide 2</h3>
            <p>This is the second slide.</p>
          </div> */}
        </div>
        <div className="carousel-slide">
          <img src={slider3} alt="Slide 3" />
          {/* <div className="carousel-caption">
            <h3>Slide 3</h3>
            <p>This is the third slide.</p>
          </div> */}
        </div>
        <div className="carousel-slide">
          <img src={slider4} alt="Slide 4" />
          {/* <div className="carousel-caption">
            <h3>Slide 4</h3>
            <p>This is the fourth slide.</p>
          </div> */}
        </div>
        
      </Slider>
    </div>
  );
}

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`${className} custom-arrow next-arrow`} onClick={onClick}>
      <i className="fa fa-chevron-right" aria-hidden="true"></i>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`${className} custom-arrow prev-arrow`} onClick={onClick}>
      <i className="fa fa-chevron-left" aria-hidden="true"></i>
    </div>
  );
};

export default ImageCarousel;
